export enum AvailableNetworks {
  polygon = 'POLYGON',
  rinkeby = 'RINKEBY',
  hardhat = 'HARDHAT',
}
export interface NetworkDataType {
  name: string;
}

export const networkData = {
  [AvailableNetworks.polygon]: {
    name: 'Polygon Mainnet',
    usdcTokenAddress: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    tokenAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    factoryAddress: '0xED79b078dFeF6618A1eA456720Fa4CD3c4E43209',
    routerAddress: '0xe8BF2801a3e457FE141407a3b39F47fDE83B376f',
    chainId: '0x89',
    ViewText: 'view on polygonscan',
    AddText: 'Add polygon to metamask',
    scanURL: 'https://polygonscan.com/tx/',
    rpcURL: 'https://polygon-rpc.com/',
    currencyName: 'MATIC',
    explorerURL: 'https://polygonscan.com/',
  },
  [AvailableNetworks.rinkeby]: {
    name: 'Ethereum Rinekby',
    usdcTokenAddress: '0x0665d35f9A136E6A347A8004865f12fbA8D8263c',
    tokenAddress: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    factoryAddress: '0xF7b95EF5Ef4372346d8f71ae4fa08Ef5423E9E6d',
    routerAddress: '0xFfe5db2061120F1e2Ea1b4d6c511C9207187ac66',
    chainId: '0x4',
    ViewText: 'view on rinkeby etherscan',
    AddText: 'Add rinkeby to metamask',
    scanURL: 'https://rinkeby.etherscan.io/tx/',
    rpcURL:
      'https://eth-rinkeby.alchemyapi.io/v2/gyDXBQzhsnscFWdaeRTg-NodgAswgf8X',
    currencyName: 'ETH',
    explorerURL: 'https://rinkeby.etherscan.io/',
  },
  [AvailableNetworks.hardhat]: {
    name: 'Hardhat network',
    usdcTokenAddress: '0x0665d35f9A136E6A347A8004865f12fbA8D8263c',
    tokenAddress: '0x7ef8E99980Da5bcEDcF7C10f41E55f759F6A174B',
    factoryAddress: '0x77c7E3905c21177Be97956c6620567596492C497',
    routerAddress: '0x03Fb741bFDc7588794D3eCaB869b3537AdeA8394',
    chainId: '31337',
    ViewText: 'view on hardhat',
    AddText: 'Add hardhat to metamask',
    scanURL: 'https://rinkeby.etherscan.io/tx/',
    rpcURL:
      'https://eth-rinkeby.alchemyapi.io/v2/gyDXBQzhsnscFWdaeRTg-NodgAswgf8X',
    currencyName: 'ETH',
    explorerURL: 'https://rinkeby.etherscan.io/',
  },
};
